import React from 'react'
import { Button } from '@/components/ui/button'
import { LabeledValue } from 'antd/es/select'
import { CreateIBProfileInstrument } from 'api/Trading-Accounts/Types/CreateIBProfileInstrument'
import { InstrumentDto } from 'api/Trading-Accounts/Types/InstrumentDto'
import {
  FormBaseAntSelectWrapper,
  FormBaseButtonContainer,
  FormBaseContainer,
  FormBaseErrorMessage,
  FormBaseFieldBlock,
  FormBaseFieldGroup,
  FormBaseFieldLabel,
  FormBaseRow,
} from 'components/Form/Form.styles'
import { MultiSelect, Option } from 'components/Select'
import { Form, FormikErrors, FormikProps, withFormik } from 'formik'
import stringComparator from 'utils/stringComparator'

export type AddIntroducingBrokerProfileInstrumentFormValues = {
  instruments: LabeledValue[]
}

const AddUserFormUI: React.FC<
  FormikProps<AddIntroducingBrokerProfileInstrumentFormValues> & OuterProps
> = (props) => {
  const { handleSubmit, setSubmitting, isSubmitting, errors, values, setFieldValue } = props

  const onSubmit = () => {
    setSubmitting(true)
    handleSubmit()
  }

  return (
    <FormBaseContainer>
      <Form>
        <FormBaseFieldBlock>
          <FormBaseRow>
            <FormBaseFieldLabel>Instruments</FormBaseFieldLabel>
            <FormBaseFieldGroup>
              <FormBaseAntSelectWrapper>
                <MultiSelect
                  placeholder='Select instruments'
                  value={values.instruments}
                  size='lg'
                  fullWidth
                  onChange={(labeledValues: LabeledValue[]) =>
                    setFieldValue('instruments', labeledValues)
                  }
                  allowClear
                  labelInValue
                >
                  <Option value='none'>None</Option>
                  {[...props.instruments]
                    .sort((a, b) => stringComparator(a.symbol, b.symbol))
                    .map((i) => (
                      <Option value={i.id} key={i.id}>
                        {i.symbol}
                      </Option>
                    ))}
                </MultiSelect>
              </FormBaseAntSelectWrapper>
            </FormBaseFieldGroup>
          </FormBaseRow>
          {errors.instruments && (
            <FormBaseErrorMessage>
              <>{errors.instruments}</>
            </FormBaseErrorMessage>
          )}
        </FormBaseFieldBlock>
        <FormBaseButtonContainer>
          <Button onClick={() => onSubmit()} disabled={isSubmitting} key='button' type='button'>
            Submit
          </Button>
        </FormBaseButtonContainer>
      </Form>
    </FormBaseContainer>
  )
}

const dataToSubmit = (
  values: AddIntroducingBrokerProfileInstrumentFormValues
): CreateIBProfileInstrument => {
  return {
    instruments: values.instruments.map((x) => x.value as string),
  }
}

interface OuterProps {
  instruments: InstrumentDto[]
  onSubmit(values: CreateIBProfileInstrument): Promise<void>
}

export const AddIntroducingBrokerInstrumentForm = withFormik<
  OuterProps,
  AddIntroducingBrokerProfileInstrumentFormValues
>({
  mapPropsToValues: () => {
    return {
      instruments: [],
    }
  },
  handleSubmit: async (values, { props, setSubmitting }) => {
    try {
      await props.onSubmit(dataToSubmit(values))
    } finally {
      setSubmitting(false)
    }
  },
  validate: (values) => {
    const errors: FormikErrors<AddIntroducingBrokerProfileInstrumentFormValues> = {}
    if (!values.instruments.length) {
      errors.instruments = 'Required'
    }
    return errors
  },
  enableReinitialize: true,
})(AddUserFormUI)
